/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SettingListResourceService } from './settings-list-resource.service';
import { SettingItemResource, SettingListResource, SettingName } from './settings.model';
import { getSettingItemResource } from './settings.util';

@Injectable()
export class SettingsService {
  private readonly settingListResourceService = inject(SettingListResourceService);

  public get<T>(name: SettingName): Observable<StateResource<SettingItemResource<T>>> {
    return this.settingListResourceService
      .getList()
      .pipe(map((list: StateResource<SettingListResource>) => getSettingItemResource<T>(list, name)));
  }
}
